// extracted by mini-css-extract-plugin
export const trees = "style-module--trees--2ysG8";
export const spruces = "style-module--spruces--2gyS8";
export const spruces__left = "style-module--spruces__left--3ZnWS";
export const spruces__right = "style-module--spruces__right--3j8U6";
export const forest = "style-module--forest--3mhGO";